import {USER_ROLES} from "@app/auth";

export const HYGRAPH_PREVIEW_ROLES = [USER_ROLES.PREVIEW_HYGRAPH_ASSETS];

export const HYGRAPH_CONTENT_STAGES = {
  PUBLISHED: 'PUBLISHED',
  PREVIEW: 'PREVIEW',
};

export const HYGRAPH_CONTENT_STAGES_LIST = [
  {
    label: 'Published',
    value: HYGRAPH_CONTENT_STAGES.PUBLISHED,
  },
  {
    label: 'Preview',
    value: HYGRAPH_CONTENT_STAGES.PREVIEW,
  },
];
